module.exports = __webpack_public_path__ + "img/icon_form_security_off.8545e0d0.svg";